import React, { ReactNode } from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { SkeletonLoader } from '../SkeletonLoader';
import { Text } from '../Text';
interface Props {
  /** Pass through classname to allow styles overrides */
  className?: string;
  /** The label to be shown next to the badge */
  label?: ReactNode;
  /** The sub label shown below the label */
  subLabel?: ReactNode;
  /** The number to be shown in the badge */
  value: number;
  /** Wether the subLabel goes below or in the same line as the label */
  singleLineLabels?: boolean;
  /** The ID of the Score Rating value */
  scoreId?: string;
  /** The ID of the Label text i.e. Superb/Good */
  scoreLabelId?: string;
  /** The ID of the SubLabel which is review count  */
  scoreSubLabelId?: string;
  /** show score rating in a single line without border-radius or background */
  isCompact?: boolean;
}
interface ScoreProps {
  id?: string;
  value: number;
  isCompactWrapper?: boolean;
}
const RatingElement = /*#__PURE__*/styled('div')({
  name: "RatingElement",
  class: "rl0rrd0",
  propsAsIs: false
});
const BadgeWrapper = /*#__PURE__*/styled('div')({
  name: "BadgeWrapper",
  class: "b1aykkis",
  propsAsIs: false
});
const LabelWrapper = /*#__PURE__*/styled('div')({
  name: "LabelWrapper",
  class: "l1ntgl08",
  propsAsIs: false
});
const _exp21 = /*#__PURE__*/() => Text;
const LabelText = /*#__PURE__*/styled(_exp21())({
  name: "LabelText",
  class: "l7yxyf",
  propsAsIs: true
});
const _exp23 = /*#__PURE__*/() => Text;
const SubLabelText = /*#__PURE__*/styled(_exp23())({
  name: "SubLabelText",
  class: "sbsslpg",
  propsAsIs: true
});
const _exp25 = /*#__PURE__*/() => Text;
export const CompactBadge = /*#__PURE__*/styled(_exp25())({
  name: "CompactBadge",
  class: "ctt7ag0",
  propsAsIs: true
});
const Score = ({
  value,
  id,
  isCompactWrapper = false
}: ScoreProps) => {
  if (isCompactWrapper) {
    if (!value) {
      return null;
    }
    return <CompactBadge id={id} variant="labelXS" align="center">
        {value}
      </CompactBadge>;
  }
  return <BadgeWrapper id={id}>{value || '-'}</BadgeWrapper>;
};
export const ScoreRatingLoader = ({
  isCompact
}: {
  isCompact?: boolean;
}) => isCompact ? <SkeletonLoader height={16} width={74} marginTop={0} /> : <SkeletonLoader height={28} width={28} marginTop={0} />;
export const ScoreRating = ({
  label,
  subLabel,
  value,
  className,
  singleLineLabels = false,
  isCompact = false,
  scoreId,
  scoreLabelId,
  scoreSubLabelId
}: Props) => <RatingElement className={cx(isCompact && 'isCompact', singleLineLabels && 'isSingleLine', value >= 7 && '--high', value < 7 && '--poor', className)}>
    <Score id={scoreId} value={value} isCompactWrapper={isCompact} />
    {(label || subLabel) && <LabelWrapper>
        {label && <LabelText id={scoreLabelId} variant={isCompact ? 'labelXS' : 'labelS'}>
            {label}
          </LabelText>}
        {subLabel && <SubLabelText tag="div" variant={singleLineLabels ? 'bodyS' : 'bodyXS'} id={scoreSubLabelId}>
            {isCompact && value > 0 ? <>({subLabel})</> : subLabel}
          </SubLabelText>}
      </LabelWrapper>}
  </RatingElement>;

require("./ScoreRating.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./ScoreRating.tsx");